export default {
      id: "keyboard-input-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#keyboard-input-usage",
      toString: function () {
        return this.url;
      }
    }